<template>
  <div v-if="showCarousel()">
    <div class="count-indicator" v-if="decisions.length">
      {{$t("draft")}} {{ initialSlide + 1 }} of {{ decisions.length }}
    </div>
    <agile
      v-if="!loading && decisions.length > 0"
      :dots="false"
      :infinite="false"
      :initial-slide="initialSlide > -1 ? initialSlide : 0"
      :autoplay="false"
      :swipe-distance="99999999"
      @after-change="showCurrentSlide($event)"
    >
      <div class="slide" v-for="(decision, index) in decisions" :key="index">
        <div class="proposed-unique-block-default-enclave">
          <ul class="ag-add-desicion-list">
            <li>
              <span class="bold-text">{{$t("role")}} : </span>
              <span class="value">{{ decision.rolePolicy }}</span>
            </li>
            <li>
              <span class="bold-text">{{$t("mode")}} : </span>
              <span class="value">{{ decision.modeName }}</span>
            </li>
            <li>
              <span class="bold-text">{{$t("action")}} : </span>
              <span class="value">{{ decision.action }}</span>
            </li>
            <li>
              <span class="bold-text">{{$t("actor")}} : </span>
              <span class="value">
                <ag-truncate
                  :text="decision.actor"
                  :options="{ position: 'middle', first: 12, last: 18 }"
                ></ag-truncate>
              </span>
            </li>
            <li>
              <span class="bold-text">{{$t("target")}} : </span>
              <span class="value">
                <ag-truncate
                  :text="decision.target"
                  v-if="decision.target"
                  :options="{ position: 'middle', first: 12, last: 18 }"
                ></ag-truncate>
              </span>
            </li>
          </ul>

          <ul class="ag-add-desicion-list" style="width: 30%">
            <li>
              <span class="bold-text">{{$t("computers")}} :</span>
              <span class="value"
                >{{ decision.effectedComputerCount }} /
                {{ decision.totalComputerCount }}</span
              >
            </li>
            <li>
              <span class="bold-text">{{$t("eventInspection")}} : </span>
              <span class="value">{{ decision.eventCount }}</span>
            </li>
            <li>
              <span class="bold-text">{{$t("decision")}} : </span>
              <span class="value">{{
                decision.decisionStatusId === 1 ? "Drafted" : "Applied"
              }}</span>
            </li>
            <li>
              <span class="bold-text">{{$t("option")}} : </span>
              <span class="value">{{ decision.decisionOptionName }}</span>
            </li>
          </ul>

          <ul class="ag-add-desicion-list" style="width: 18%">
            <li>
              <a
                href="#"
                @click="setSelected(decision)"
                data-toggle="modal"
                class="ag-table-button"
                data-target="#editDecision"
                ><i class="ag-icon ag-icon_edit_borderless mr-1"></i>{{$t("editDesicion")}}</a
              >
            </li>
            <li>
              <router-link
                class="ag-table-button"
                to="/administration/policy-review"
                ><i class="ag-icon ag-icon_greyLeftArrow mr-1"></i>{{$t("returnReview")}}</router-link
              >
            </li>
          </ul>

          <ul class="ag-add-desicion-list" style="width: 12%">
            <li class="form-group">
              <label for="drafted">
                <input
                  type="radio"
                  id="drafted"
                  value="1"
                  v-model="decision.decisionStatusId"
                  name="decisionStatusId"
                  :checked="decision.decisionStatusId === 1"
                />
                {{$t("drafted")}}
              </label>
              <img
                src="~@/assets/image/checked.png"
                v-if="decision.decisionStatusId == 1"
                alt=""
                style="
                  position: absolute;
                  width: 30px;
                  margin-left: -6px;
                  margin-top: -8px;
                "
              />
            </li>
            <li class="form-group">
              <label for="applied">
                <input
                  type="radio"
                  id="applied"
                  value="2"
                  v-model="decision.decisionStatusId"
                  name="decisionStatusId"
                  :checked="decision.decisionStatusId === 2"
                />
                {{$t("applied")}}
                <img
                  src="~@/assets/image/checked.png"
                  v-if="decision.decisionStatusId == 2"
                  alt=""
                  style="
                    position: absolute;
                    width: 30px;
                    margin-left: -6px;
                    margin-top: -3px;
                  "
                />
              </label>
            </li>
          </ul>

          <ul class="ag-add-desicion-list" style="width: 15%">
            <li class="form-group">
              <button
                type="button"
                @click="save(decision)"
                class="
                  ag-button_primary
                  ag-button
                  border-0
                  ag-button_radius
                  pr-4
                  pl-4
                  pt-2
                  pb-2
                "
              >
                {{$t("save")}}
              </button>
            </li>
          </ul>
        </div>
      </div>
    </agile>

    <div
      v-if="!loading && decisions.length === 0"
      class="
        proposed-unique-block-default-enclave
        d-flex
        flex-column
        align-items-center
        text-center
        justify-content-center
        pt-4
        mpb-4
      "
    >
      <span class="text-danger mb-3 mt-3"
        >{{$t("reviewCaraouselText")}}</span
      >
      <span class="text-danger mb-3 mt-3 d-flex align-items-center">
        {{$t("thereAre")}} {{ countData ? countData.uniqueBlocks : "no " }} {{$t(" more blocks if you would like to draft them in")}}
        <router-link
          to="/administration/policy-review"
          class="ag-table-button ml-2"
          >{{$t("returnReview")}}
        </router-link>
      </span>

      <span class="mb-3 mt-3"
        >{{$t("reviewCaraouselText2")}}</span
      >
    </div>
    <!-- <div
      class="row"
      style="margin-top: -30px"
      v-if="
        $route.fullPath.indexOf('policy-tuning') > -1 ||
        $route.fullPath.indexOf('showButton')
      "
    >
      <div class="col-2 mb-2" v-for="(item, i) in shortLinks" :key="i">
        <router-link
          :to="{ path: item.link, query: { showButton: true } }"
          class="ag-table-button"
        >
          {{ t(item.title) }}
        </router-link>
      </div>
    </div> -->
    <ag-add-decision-modal @submit="updateDecision"></ag-add-decision-modal>
    <ag-loading v-if="loading" />
  </div>
</template>

<script>
import { computed, defineComponent, reactive, ref } from "vue";
import { useStore } from "@/store";
import { GeneralActionTypes } from "../../store/modules/general/action-types";
import AgLoading from "@/components/ag-loading/index.vue";
import AgAddDecisionModal from "@/components/ag-add-decision-modal/index.vue";
import { mapState, mapGetters } from "vuex";
import { Roles } from "@/helpers/enums/Roles";
import AgTruncate from "@/components/ag-truncate/index.vue";
import { VueAgile } from "vue-agile";
import axiosAgsc from "@/store/axiosAgsc";
import { notify } from "@kyvg/vue3-notification";
import $ from "jquery";
import moment from "moment";
import api from "@/api/index";
import { useI18n } from "vue-i18n";

const store = useStore();

export default defineComponent({
  name: "ag-review-carousel",
  data() {
    return {
      loading: false,
      progress: false,
      Roles: Roles,
      initialSlide: 0,
      decisions: [],
      decisionStatusId: 0,
      countData: null,
     shortLinks: [
        //{
        //title: "defaultEnclave",
        //link: "default-enclave",
        //},
       
        //{
        //  title: "powerApps",
        //  link: "power-apps",
        //},
        //{
        //  title: "trustedFolders",
        //  link: "trusted-folders",
        //},
        //{
        //  title: "globalPolicy",
        //  link: "global-policy",
        //},
        //{
        //  title: "codeLoad",
        //  link: "code-load",
        //},
        // {
        //   title: "netlockPolicy",
        //   link: "netlock-policy",
        // },
        //{
        //  title: "trustedEnclave",
        //  link: "trusted-enclave",
        //},
        {
          title: "removableMedia",
          link: "removable-media",
        },
         {
          title: "trustedPublishers",
          link: "trusted-publishers",
        },
        // {
        //   title: "customScripts",
        //   link: "custom-scripts",
        // },
        //{
        //  title: "spaceRule",
        //  link: "space-rule",
        //},
        {
          title: "ignoreEvents",
          link: "ignore-events",
        },
        {
          title: "severityEvents",
          link: "severity-events",
        },
        //{
        //  title: "fileExtensions",
        //  link: "file-extensions",
        //},
        {
          title: "summaryEvents",
          link: "summary-events",
        },
      ],
    };
  },
  setup() {
    const { t, locale } = useI18n();
    return { t, locale };
  },
  components: {
    AgLoading,
    AgTruncate,
    agile: VueAgile,
    AgAddDecisionModal,
  },
  computed: {
    ...mapState({
      site: (state) => state.auth.site,
      group: (state) => state.auth.group,
    }),
    ...mapGetters(["loggedInUser"]),
  },
  methods: {
    showCarousel() {
      return (
        this.loggedInUser.role === Roles.GroupAdmin &&
        (this.$route.fullPath.indexOf("/policy-tuning") > -1 ||
          this.$route.fullPath.indexOf("showButton") > -1 ||
          this.$route.fullPath.indexOf("/default-enclave?mainId=") > -1 ||
          this.$route.fullPath.indexOf("/group-dashboard?showCompleted") > -1)
      );
    },
    showCurrentSlide(event) {
      this.initialSlide = event.currentSlide;
    },
    async updateDecision(data) {
      const body = {
        id: data.id,
        decisionStatusId: data.decisionStatusId,
        decisionOptionId: data.decisionOptionId,
        option: data.option,
        decisionId: data.decisionId,
        scope: data.scope,
      };
      await store.dispatch(
        GeneralActionTypes.UPDATE_REVIEW_CHECKLIST_ITEM,
        body
      );
      $($("#editDecision")[0]).removeClass("show");
      $($("#editDecision")[0]).css("display", "none");
      $("body").removeClass("modal-open");
      $(".modal-backdrop").remove();
      notify({
        title: "Saved",
        type: "success",
        duration: 4000,
      });
      store.dispatch(GeneralActionTypes.SET_COMPKEY, store.getters.compKey + 1);
    },
    async save(decision) {
      this.loading = true;
      const body = {
        id: decision.id,
        decisionStatusId: decision.decisionStatusId,
        decisionOptionId: decision.decisionOptionId,
        option: decision.option,
        decisionId: decision.decisionId,
        scope: decision.scope,
      };
      try {
        await store.dispatch(
          GeneralActionTypes.UPDATE_REVIEW_CHECKLIST_ITEM,
          body
        );
        notify({
          title: "Decision status has been updated!",
          type: "success",
          duration: 4000,
        });
        if (this.initialSlide < this.decisions.length - 1) {
          ++this.initialSlide;
        } else {
          this.initialSlide = 0;
        }
        this.loading = false;
        this.loadData("update");
      } catch (error) {
        console.log(error);
        this.loading = false;
      }
    },
    setSelected(decision) {
      store.dispatch(GeneralActionTypes.SET_SELECTED_ROW, decision);
    },
    loadData(type) {
      if (localStorage.getItem("decisionStatusId")) {
        this.decisionStatusId = localStorage.getItem("decisionStatusId");
      }

      if (this.$route.query.decisionStatusId) {
        this.decisionStatusId = this.$route.query.decisionStatusId;
      } else {
        this.decisionStatusId = 1;
      }

      if (this.$route.fullPath.indexOf("administration/policy-tuning") > -1) {
        axiosAgsc
          .post("PolicyReview/ListReviewCheckList", {
            decisionId: 1,
            decisionStatusId: 1,
            page: 1,
            limit: 20,
            startDate: moment().startOf("day").subtract(7, "days").utc(),
            endDate: moment().utc(),
          })
          .then((res) => {
            this.decisions = res.data.entityData;
            if (this.decisions.length === 0) {
              this.$router.push({
                path: "/administration/group-dashboard",
                query: { showCompleted: "true" },
              });
            }
          });
      }

      if (this.decisionStatusId) {
        this.loading = true;
        localStorage.setItem("decisionStatusId", this.decisionStatusId);
        const rowId = this.$route.query.rowId;
        axiosAgsc
          .post("PolicyReview/ListReviewCheckList", {
            decisionId: 1,
            decisionStatusId: parseInt(this.decisionStatusId),
            page: 1,
            limit: 20,
            startDate: moment().utc().startOf("day").subtract(7, "days"),
            endDate: moment().utc(),
          })
          .then((res) => {
            this.decisions = res.data.entityData;
            if (type != "update") {
              this.initialSlide = this.decisions.findIndex(
                (i) => i.id === rowId
              );
            }
            if (type == "update") {
              if (this.decisions.length === 0) {
                this.$router.push({
                  path: "/administration/group-dashboard",
                  query: { showCompleted: "true" },
                });
              }
            }
          })
          .finally(() => {
            this.loading = false;
          });
      }
    },
  },
  async mounted() {
    this.loadData();
    let pStartDate = moment().startOf("day").subtract(7, "days").utc().format("YYYY-MM-DDTHH:mm:ss.SSS");
    let pEndDate = moment().utc().format("YYYY-MM-DDTHH:mm:ss.SSS");
    let polPayload = {
      startDate: pStartDate,
      endDate: pEndDate,
    };
    const res = await api.policyReview.getPolicyReviewDashboard(polPayload);
    if(res.data.entityData && res.data.entityData.companies && res.data.entityData.companies.length > 0) {
      if(res.data.entityData.companies[0].sites.length > 0 && res.data.entityData.companies[0].sites[0].groups > 0) {
        this.countData = res.data.entityData.companies[0].sites[0].groups[0];
      }
    }
  },
});
</script>

<style>
.shortcut-btns {
  display: flex;
  align-items: center;
  justify-content: flex-start;
  flex-wrap: wrap;
}
.agile__nav-button--prev {
  left: 16px;
  background: none;
  border: 0px;
  color: #4c8dbb;
  font-size: 32px;
  margin-left: 12px;
}

.agile__actions {
  position: relative;
  top: -160px;
  height: 1px;
}

.agile__nav-button--next {
  right: 16px;
  background: none;
  border: 0px;
  color: #4c8dbb;
  font-size: 32px;
  margin-right: 12px;
}

.agile__nav-button[disabled] {
  cursor: default;
  opacity: 0.3;
}
</style>
<style scoped lang="scss">
a.router-link-active.ag-table-button {
  background: #4c8dbb;
  color: #fff;
}
.count-indicator {
  position: relative;
  margin-bottom: -32px;
  z-index: 9999;
  margin-left: 12px;
  color: #8e8e8e;
}
.agile__nav-button {
  background: transparent;
  border: none;
  color: #fff;
  cursor: pointer;
  font-size: 24px;
  height: 100%;
  position: absolute;
  top: 0;
  transition-duration: 0.3s;
  width: 80px;
}
.agile__nav-button:hover {
  background-color: rgba(0, 0, 0, 0.5);
  opacity: 1;
}

.proposed-unique-block-default-enclave {
  border-radius: 8px;
  padding: 12px 24px;
  width: 100%;
  margin-bottom: 20px;
  border: 2px solid #b7c6cd;
  background: #fff;
  display: flex;
  align-items: center;
  margin-bottom: 50px;

  .ag-add-desicion-list {
    list-style: none;
    padding: 0;
    margin: 15px 0;
    flex-wrap: wrap;
    width: 45%;
  }

  .ag-add-desicion-list label {
    font-size: 16px !important;
  }

  .ag-add-desicion-list.wrap {
    padding-top: 70px;
    justify-content: center;
    align-items: center;
  }

  .ag-add-desicion-list li {
    flex-direction: row;
    display: flex;
    list-style: none;
    margin: 0;
    padding: 6px 15px;
    flex-grow: 1;
    align-items: center;
    justify-content: flex-start;
  }

  .ag-add-desicion-list li .form-group {
    padding: 10px 0px;
  }

  .form-group label {
    display: flex;
    align-items: center;
    input {
      margin-right: 6px;
    }
  }

  .ag-add-desicion-list li .bold-text {
    color: #5e5e5e;
    font-weight: bold;
    font-size: 16px;
    text-align: right;
    width: 30%;
  }

  .ag-add-desicion-list li .value {
    color: #8e8e8e;
    font-size: 30px;
    color: #8e8e8e;
    font-size: 16px;
    margin-left: 10px;
    text-align: left;
    width: 70%;
    display: flex;
    align-items: center;
    justify-content: flex-start;
  }

  .ag-add-desicion-list li .value.form-item {
    display: flex;
    align-items: center;
    justify-content: space-around;
    width: auto;
  }

  .ag-add-desicion-list li .value.form-item .form-group input[type="radio"] {
    margin-right: 8px;
  }
}
</style>
